import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

export const recyclingCouponFilters: () => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = () => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
  },
  {
    key: 'postedAt',
    label: '게시 시작 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['onAt', 'offAt'],
  },
  {
    key: 'createdAt',
    label: '등록 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'sponsorNameLike',
    label: '후원사 명',
    placeholder: '후원사 명을 입력해주세요',
  },
  {
    key: 'isExposed',
    label: '노출 여부',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '노출', value: 'true' },
      { label: '미노출', value: 'false' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
];
